import { FC } from 'react';

/**
 * Full Page Loader
 * Ultra-minimalist, professional design.
 * Focusing on stability, clarity, and brand integrity.
 * No decorative effects.
 */
interface FullPageLoaderProps {
    message?: string;
}

export const FullPageLoader: FC<FullPageLoaderProps> = ({
    message
}) => {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-10">
                {/* Static, High-Quality Brand Logo */}
                <img
                    src="/carion.jpg"
                    alt="Carion Group"
                    className="w-52 h-auto object-contain"
                />

                {/* Standard, Professional Spinner */}
                <div className="flex flex-col items-center gap-4">
                    <div
                        className="w-6 h-6 border-2 border-slate-100 border-t-blue-600 rounded-full animate-spin"
                        style={{ animationDuration: '0.8s' }}
                    />

                    {/* Optional Status Text - Only if provided */}
                    {message && (
                        <span className="text-xs font-medium text-slate-400">
                            {message}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FullPageLoader;
